module.exports = __webpack_public_path__ + "img/gj_text.b16b679f.png";